import { faqItems } from '@/mocks/categories';

export default function FaqSection() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section id="faq" className="py-16 md:py-24 bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="px-6 md:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-tealwarm-700 uppercase tracking-wide mb-3">
            <span className="w-1.5 h-1.5 rounded-full bg-tealwarm-500"></span>
            FAQ
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-warm-950">
            Domande Frequenti su{' '}
            <span className="text-tealwarm-600">Itaobuy Spreadsheet</span>
          </h2>
          <p className="mt-3 text-sm text-warm-500 max-w-lg mx-auto">
            Tutto quello che devi sapere sul nostro itaobuy spreadsheet: risposte chiare e dirette alle domande più comuni.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {faqItems.map((item, i) => (
            <div key={i} className="bg-cream-50 rounded-2xl p-6 hover:bg-cream-100 transition-colors">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-8 h-8 rounded-full bg-tealwarm-100 flex items-center justify-center text-tealwarm-700 flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold">Q</span>
                </div>
                <h3 className="text-base font-bold text-warm-900 leading-snug">{item.question}</h3>
              </div>
              <p className="text-sm text-warm-600 leading-relaxed ml-11">{item.answer}</p>
              <div className="mt-4 ml-11 flex items-center gap-2">
                <span className="text-xs text-warm-400">itaobuy sheet</span>
                <span className="text-xs text-warm-300">•</span>
                <span className="text-xs text-warm-400">Aggiornato 2026</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}